// Rotas de contexto não abrem aba pelo afterEach (o próprio contexto cuida da aba com o nome do menu).
const CONTEXT_ROUTES = ['context', 'context_id', 'context_filter', 'context_template_filter', 'admin_mode']

// A rota coringa ("/:pathMatch(.*)*", nome "404") atende qualquer endereço desconhecido (favorito antigo, link
// digitado errado, "/tag/filtros"...). Abrir aba para ela gerava uma "Janela sem título" que ainda era gravada no
// localStorage e voltava a cada recarga.
export function opensTab (to) {
  return !!to && !!to.name && to.name !== '404' && !CONTEXT_ROUTES.includes(to.name)
}

// Abas salvas de sessões anteriores: descarta as que hoje caem na rota coringa (rota que não existe mais).
// "resolve" é o router.resolve; se falhar, a aba é mantida (melhor uma aba a mais do que perder uma válida).
export function restorablePages (pages, resolve) {
  if (!Array.isArray(pages)) return []

  return pages.filter((page) => {
    if (!page || !page.fullPath) return false

    try {
      return resolve(page.fullPath).name !== '404'
    } catch (e) {
      return true
    }
  })
}
